import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-arrow-up",
  "use": "svgIcon-arrow-up-usage",
  "viewBox": "0 0 98 98",
  "content": "<symbol fill-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"2\" viewBox=\"0 0 98 98\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-arrow-up\"><path d=\"m34.5 13.3-33.9 33.9c-.8.8-.8 2.1 0 2.9l33.9 33.9c.8.7 2 .7 2.8 0l9-9.1c.4-.3.6-.9.6-1.4s-.2-1-.6-1.4l-14.5-14.5h63.5c1.1 0 2-.9 2-2v-13.9c0-1.1-.9-2-2-2h-63.5l14.5-14.5c.8-.8.8-2.1 0-2.8l-9-9.1c-.4-.3-.9-.6-1.4-.6s-1 .3-1.4.6z\" fill=\"currentColor\" fill-rule=\"nonzero\" transform=\"matrix(0 1 -1 0 97.3 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol